import React, { useState, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight, CheckCircle, MessageSquareQuote } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "Drey O.",
    role: "Business Owner, Lagos",
    trade: "Sold 500 USDT",
    text: "SphereX always comes through whenever I need to change my crypto to Naira. My bank account was credited in less than 2 minutes.",
    image: "https://res.cloudinary.com/dpfypsgyo/image/upload/v1767994230/memoji_iicy9l.png",
  },
  {
    id: 2,
    name: "Chuks M.",
    role: "Freelance Designer, Abuja",
    trade: "Sold $200 Steam Card",
    text: "SphereX customer support is always active and super friendly. The gift card rate was the best I found online, no stories at all.",
    image: "https://res.cloudinary.com/dpfypsgyo/image/upload/v1767994230/memoji_1_j3hffj.png",
  },
  {
    id: 3,
    name: "Habeeb K.",
    role: "Forex & Crypto Trader, Ibadan",
    trade: "Sold 1,200 USDT",
    text: "I love their instant payment and sweet rates. I've done over 10 transactions here and every single one was smooth and fast.",
    image: "https://res.cloudinary.com/dpfypsgyo/image/upload/v1767994230/memoji_3_ql1quf.png",
  },
  {
    id: 4,
    name: "Michael E.",
    role: "Digital Marketer, Port Harcourt",
    trade: "Sold $150 Apple Gift Card",
    text: "SphereX gives the sweetest rates for crypto and gift cards. The web dashboard is so simple to use even for first-timers.",
    image: "https://res.cloudinary.com/dpfypsgyo/image/upload/v1767994230/memoji_2_ongul2.png",
  },
];

export default function Testimonial() {
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-white px-4 sm:px-6 lg:px-8" id="testimonials">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-bold uppercase tracking-wider mb-3">
            <MessageSquareQuote className="w-3.5 h-3.5" />
            <span>Real Feedback</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
            Loved by Everyday Traders
          </h2>
          <p className="mt-3 text-base text-gray-600">
            See why thousands of Nigerians rely on SphereX for their everyday crypto and gift card exchanges.
          </p>
        </div>

        {/* Featured Testimonial Card */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-purple-50/50 via-white to-slate-50 border border-purple-100 rounded-3xl p-6 sm:p-10 shadow-sm relative">
          
          {/* Avatar Navigation Row */}
          <div className="flex items-center justify-center gap-4 sm:gap-6 mb-8">
            {testimonials.map((t, index) => (
              <button
                key={t.id}
                onClick={() => setCurrent(index)}
                className={`relative rounded-full transition-all duration-300 focus:outline-none ${
                  index === current
                    ? "ring-4 ring-purple-600 ring-offset-2 scale-110"
                    : "opacity-40 grayscale hover:opacity-75"
                }`}
                aria-label={`View review from ${t.name}`}
              >
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover bg-purple-100"
                />
              </button>
            ))}
          </div>

          {/* Star Rating Icons (No emojis) */}
          <div className="flex items-center justify-center gap-1 text-amber-400 mb-5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
            ))}
          </div>

          {/* Quote Text */}
          <blockquote className="text-center text-lg sm:text-2xl font-medium text-gray-800 leading-relaxed mb-6">
            “{testimonials[current].text}”
          </blockquote>

          {/* User Info */}
          <div className="text-center">
            <div className="flex items-center justify-center gap-2">
              <span className="font-bold text-gray-900 text-base">
                {testimonials[current].name}
              </span>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-100/80 px-2 py-0.5 rounded-full">
                <CheckCircle className="w-3 h-3 text-emerald-600" />
                <span>Verified Trader</span>
              </span>
            </div>
            <p className="text-xs sm:text-sm text-gray-500 mt-1">
              {testimonials[current].role} &bull; <span className="text-purple-600 font-medium">{testimonials[current].trade}</span>
            </p>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-between mt-8 pt-6 border-t border-purple-100/80">
            <button
              onClick={prevSlide}
              className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-gray-600 hover:text-purple-600 bg-white hover:bg-purple-50 border border-gray-200 px-4 py-2 rounded-full transition-all shadow-sm"
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-4 h-4" />
              <span>Previous</span>
            </button>

            <div className="flex items-center gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`h-2 rounded-full transition-all ${
                    current === i ? "bg-purple-600 w-6" : "bg-gray-200 w-2 hover:bg-gray-300"
                  }`}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextSlide}
              className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-white bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded-full transition-all shadow-sm"
              aria-label="Next testimonial"
            >
              <span>Next</span>
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>

        </div>

      </div>
    </section>
  );
}
